import { useMemo } from 'react';
import uniqueId from 'transmute/uniqueId';
import AddMetricButton from './AddMetricButton';
import MetricsEditorInputGroup from './MetricsEditorInputGroup';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const MetricEditor = ({
  'data-test-id': dataTestId,
  addMetricDisabledReason,
  buttonUse,
  dropdownFooter,
  getAggregationOptions,
  getAggregationDisabledReason,
  hideAddButton = false,
  isDeleteDisabled = () => false,
  isAggregationDisabled = () => false,
  onAddMetric,
  onDeleteMetric,
  onMetricChange,
  propertyOptions,
  reportMetrics
}) => {
  // Build unique keys for each of the metrics for the map function to prevent react UI bugs
  const metricKeys = useMemo(() => {
    return reportMetrics.map(metric => `${metric.property}-${uniqueId('metric-')}`);
  }, [reportMetrics]);
  return /*#__PURE__*/_jsxs("div", {
    children: [metricKeys.map((metricKey, index) => /*#__PURE__*/_jsx(MetricsEditorInputGroup, {
      reportMetric: reportMetrics[index],
      metricIndex: index,
      propertyOptions: propertyOptions,
      onChange: metric => onMetricChange(index, metric),
      onDelete: () => onDeleteMetric === null || onDeleteMetric === void 0 ? void 0 : onDeleteMetric(index),
      deleteDisabled: isDeleteDisabled(index),
      "data-test-id": dataTestId,
      buttonUse: buttonUse,
      dropdownFooter: dropdownFooter,
      aggregationDisabled: isAggregationDisabled(index),
      aggregationDisabledReason: getAggregationDisabledReason === null || getAggregationDisabledReason === void 0 ? void 0 : getAggregationDisabledReason(index),
      aggregationOptions: getAggregationOptions(index)
    }, metricKey)), !hideAddButton && /*#__PURE__*/_jsx(AddMetricButton, {
      disabledReason: addMetricDisabledReason,
      onClick: () => onAddMetric === null || onAddMetric === void 0 ? void 0 : onAddMetric(),
      hidden: false,
      "data-test-id": `${dataTestId}-add-metric`
    })]
  });
};
export default MetricEditor;